import React from 'react';
import Loading from '../Loading';
import PropTypes from 'prop-types';

const ContentLoadingWrapper = ({
  error,
  errorMessage = 'An error has occurred, please try again.',
  loading,
  content,
}) => {
  if (error) return <p className='text-center'>{errorMessage}</p>;

  if (loading) return <Loading />;

  if (content) return content();

  return false;
};

ContentLoadingWrapper.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  loading: PropTypes.bool,
  content: PropTypes.func,
};

export default ContentLoadingWrapper;
